import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'bots-empty',
    templateUrl: 'bots-empty.component.html',
    styleUrls: ['bots-empty.component.scss']
})
export class BotsEmptyComponent {
}
